import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, Observable, Subject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  baseUrl = environment.baseUrl;

  API_URL = {
    verifyProductKey: 'api/v1/user/verify-product-key',

    verifyEmailwithActivation: 'api/v1/user/verify-act-email',
    signup: 'api/v1/user/sign-up',
    emailGenerateOtp: 'api/v1/user/generate-otp',
    signupOtpVerification: 'api/v1/user/otp-verification',
    forgotPasswordOtpVerification: 'api/v1/user/forgot-password-otp-verification',
    signIn: 'api/v1/user/sign-in',
    publicForgotPassword: 'api/v1/user/forgot-password',
    verifyOTP: 'api/v1/user/verify-otp',
    // publicRefreshToken: 'api/v1/user/refresh-access-token',

    // Manage Device API's
    getAllDeviceDetail: 'api/v1/device/get-all',
    getDesktopProductKeyDetails:
      'api/v1/device/get-desktop-product-key-details',
    getMobileProductKeyDetails: 'api/v1/device/get-mobile-product-key-details',
    getDevicesInUser: 'api/v1/device/get-device-in-user-tree',
    getSystemInUser: 'api/v1/device/get-system-in-user-tree',
    getPremiumDeviceInUser: 'api/v1/device/get-premium-device-in-user-tree',
    getUserDeviceL: 'api/v1/device/get-all-device/',
    deviceProductKey: 'api/v1/device/verify-product-key',
    deviceSendOtp: 'api/v1/device/send-otp',
    addDevice: 'api/v1/device/add-device',
    transferOwnership: 'api/v1/device/transfer-owner-ship',
    setAsDefault: 'api/v1/device/mark-device-default',
    removeDevice: 'api/v1/device/remove-device',
    generateOTP: 'api/v1/user/generate-otp',
    addUserOtpVerification: 'api/v1/user/mobile-verification',
    otpVerification: 'api/v1/user/otp-verification',
    pendingOtp: 'api/v1/device/get-pending-otp',

    // Manage User
    addUser: 'api/v1/admin/add',
    verifyLink: 'api/v1/admin/', //{sequenceId}'

    // common
    getAllUsers: 'api/v1/admin/get-all',
    signOut: 'api/v1/user/sign-out',
    getMyAccountData: 'api/v1/user/get-my-account',
    verifyAuthorizationCode: 'api/v1/user/verify-authorization-code',
    getSocialUrl: 'api/v1/user/get-social-url',
    getManageUserTreeView: 'api/v1/admin/get-users-tree',
    getVerifyLinkforEmailSignup: 'api/v1/admin/verify-link',
    signupAssignedUrl: 'api/v1/admin/sign-up-assigned-user',
    checkUserBeforeDeleting: 'api/v1/admin/check-device',
    deleteAssignedUser: 'api/v1/admin/delete',
    changeOrUpdatePassword: 'api/v1/user/change-password',
    saveOrUpdateMyAccount: 'api/v1/user/account',
    saveOrUpdateUserAccount: 'api/v1/user/user-account',
    uploadFileToS3: 'api/v1/common/get-upload-pre-signed-url',
    getDownloadPreSignedurl: 'api/v1/common/get-download-pre-signed-url',
    getAllMyLicense: 'api/v1/license/get-all-my-license',
    getAllUserLicense: 'api/v1/license/get-all-user-license',
    deleteUploadedProfile: 'api/v1/file/delete-file',
    getAllDevices: 'api/v1/device/get-all',
    addDeviceSendOtp: 'api/v1/device/send-otp',
    manageDeviceTransferOwnership: 'api/v1/device/transfer-owner-ship',
    getDeviceDetailsById: 'api/v1/device/get/',
    gettransferownershipuser: 'api/v1/admin/get-transfer-ownership-user',
    cancelOTPManageDevice: 'api/v1/device/cancel-otp',
    removeAddedDevice: 'api/v1/device/remove',
    removeLicense: 'api/v1/license/delete/',
    setDefault: 'api/v1/device/set-default',
    checkVerifiedMobile: 'api/v1/device/check-mobile-verified',
    sendCommand: 'api/v1/device/send-command',
    resendFailedCommand: 'api/v1/device/send-failure-command',
    getSettingStatus: 'api/v1/device/getSettingStatus/',

    //  Setting API
    changePin: 'api/v1/setting/change-pin',
    getChangePinById: 'api/v1/setting/get-pin/',
    getMobileDevice: 'api/v1/device/get-mobile-device',
    saveSecuritySetting: 'api/v1/setting/save-security-setting',
    getSecuritySetting: 'api/v1/setting/get-security-setting/',
    getAntiSpywareSetting: 'api/v1/setting/get-antispyware/',
    saveScanSetting: 'api/v1/setting/save-schedule-scan',
    getScheduleScan: 'api/v1/setting/get-schedule-scan/',
    saveAntiTheft: 'api/v1/setting/save-anti-theft-setting',
    getAntiTheft: 'api/v1/setting/get-anti-theft/',
    saveParentalControl: 'api/v1/setting/save-parental-control',
    getParentalControl: 'api/v1/setting/get-parental-control/',
    publish: 'api/v1/device/publish',
    restoreDefault: 'api/v1/setting/restore-default',
    getDeviceByUserId: 'api/v1/device/get-all-device',
    getLicenseHistory: 'api/v1/license/get-license-history',
    updateToggle: 'api/v1/setting/update-toggle',
    getBlockyoutube: 'api/v1/setting/get-youtube/',
    saveYoutubeSuperVision: 'api/v1/setting/save-youtube',
    saveScreentime: 'api/v1/setting/save-screen-time',
    saveDesktopSettings: 'api/v1/setting/update-desktop-toggle',
    desktopPublish: 'api/v1/device/publish-desktop-setting',
    getScreentime: 'api/v1/setting/get-screen-time/',
    getDesktopSetting: 'api/v1/setting/get-protection-setting/',
    getDesktopScanSetting: 'api/v1/setting/get-desktop-scan-setting/',
    saveDesktopParentalSetting: 'api/v1/setting/save-desktop-parental-setting',

    // Activity History
    getAllActivityHistory: 'api/v1/activity/get-all',
    getErrorCodeData: 'api/v1/activity/get-error-code-data/',
    getFamilyPackData: 'api/v1/license/get-family-pack-data/',
    getMyUsers: 'api/v1/admin/get-my-users',
    getCommands: 'api/v1/device/get-command-data/',
    updateDevice: 'api/v1/device/update-device',
    updateUsername: 'api/v1/device/update-username',
    getLocation: 'api/v1/device/get-location/',
    deleteLocation: 'api/v1/device/delete-location/',
    getLock: 'api/v1/device/get-lock/',
    getAntitheftCommandData: 'api/v1/device/get-anti-theft-auto/',

    //  Reports API
    getUserSentScheduleStatus:
      'api/v1/report/parental/get-user-scheduled-status/',
    traceDeviceSettings: 'api/v1/device/save-trace-setting',
    saveSchedule: 'api/v1/report/parental/save-schedule',
    getUserScheduledStatus: 'api/v1/report/parental/get-user-scheduled-status/',
    getSchedule: 'api/v1/report/parental/get-schedule/',
    deleteSchedule: 'api/v1/report/parental/delete-schedule-parental-report/',
    getCatwiseWeeklyScreentime:
      'api/v1/report/screen-time/get-catwise-weekly-graph-data/',
    youTubeReports: 'api/v1/report/youtube/get-line-graph-data/',
    youTubeTableData: 'api/v1/report/youtube/get-table-data/',
    youtubeUsageReport: 'api/v1/report/youtube/get-youtube-usage-data/',
    youtubeBlockedVideos: 'api/v1/report/youtube/get-blocked-videos-access/',
    youtubeBlockedChannels:
      'api/v1/report/youtube/get-blocked-channels-access-data/',
    youtubeSettings: 'api/v1/report/youtube/get-youtube-settings/',
    threatReports: 'api/v1/report/threat/get-line-graph-data/',
    threatReportsDevices: 'api/v1/report/threat/get-line-graph-data-userwise/',
    threatDonutReport: 'api/v1/report/threat/get-donut-graph-data/',
    threatTableReport: 'api/v1/report/threat/get-table-data/',
    firewallTableReport: 'api/v1/report/firewall/get-table-data/',
    idsIpsTableReport: 'api/v1/report/ids-ips/get-table-data/',
    screentimeBarReport: 'api/v1/report/screen-time/get-line-graph-data/',
    screentimeweeklyGraphData:
      'api/v1/report/screen-time/get-weekly-graph-data/',
    screentimedoughnutReport: 'api/v1/report/screen-time/get-donut-graph-data/',
    screenTimeTableReport: 'api/v1/report/screen-time/get-table-data/',
    getScreentimeSettings: 'api/v1/report/screen-time/get-screentime-settings/',
    getUserWiseAntiTrackerReport:
      'api/v1/report/anti-tracker/get-userwise-antitracker-report/',
    getDeviceWiseAntiTrackerReport:
      'api/v1/report/anti-tracker/get-devicewise-antitracker-report/',

    // Dashboard APi
    getDashboardDataById: 'api/v1/get-dashboard/',
    getScoreManagement: 'api/v1/get-score-management',
    getUserWiseScreentime:
      'api/v1/report/screen-time-userwise/get-line-graph-data/',
    getTraceSetting: 'api/v1/device/get-trace-setting/',
    getAllcampaignsData: 'api/v1/get-dashboard/campaign/',
    getAllcampaignsDataLatest: 'api/v1/get-dashboard/campaignlatest/',
    getdashboardDataByuserId: 'api/v1/get-avarage-dashboard/',

    //notifications APIs
    getNotifications: 'api/v1/get-notifications/',
    saveNotificationTime: 'api/v1/save-notification-time',
    getAllNotifications: 'api/v1/get-all-notifications/',

    //  Parental Reports API
    getAppData: 'api/v1/report/parental/get-app-data/',
    getRestrictedAppHit: 'api/v1/report/parental/get-rest-app-hit/',
    getRestictedHitsPerDevice:
      'api/v1/report/parental/get-app-web-hits-devicewise/',
    getWebData: 'api/v1/report/parental/get-web-data/',
    getWebAppLineGraphData:
      'api/v1/report/parental/get-web-app-line-graph-data/',
    getParentalSettings: 'api/v1/report/parental/get-parental-setting/',
    //   Encryption APi
    getRandaomUID: 'api/v1/user/get-random-uid',
    saveAESKey: 'api/v1/user/save-aes-key',
    getSystemMobileData: 'api/v1/device/get-system-mobile-data',
    getLastUpdatedOn: 'api/v1/device/get-last-updated-date/',

    //Desktop Setting APIs
    getDeskSafeBankingAPI: 'api/v1/setting/get-desktop-SafeBanking-setting/',
    getDeskSandboxSettingsAPI: 'api/v1/setting/get-desktop-sandbox-setting/',
    getDeskProtectionSettingsAPI:
      'api/v1/setting/get-desktop-protection-setting/',
    getDeskScanSettingsAPI: 'api/v1/setting/get-desktop-scan-setting-v1/',
    getDeskParentalSettingsAPI: 'api/v1/setting/get-desktop-parental-setting/',
    applySettingsToOtherDesktops: 'api/v1/setting/apply-settings-other-device',

    saveFile: "api/v1/file/save-multipart-file",
    saveBase64Image: "api/v1/file/save-base64String-file",

    resetPassword: "/api/v1/user/reset-password",
    resetPasswordDetails: "/api/v1/user/reset-password/details"
  };

  constructor(
    private _httpclient: HttpClient,
    private toastr: ToastrService,
    private route: Router,
    private activatedRouter: ActivatedRoute
  ) { }

  /**
   * Get Method getting Data From Back-End   --Deepa
   * @param url
   * @param params
   * 10-02-2020
   * Added HttpHeaders to call security based api
   */
  getService(url: string, params?: any) {
    const httpOptions = this.getHttpHeader();
    return this._httpclient
      .get(this.baseUrl + url, httpOptions)
      .pipe(
        map((response: any) => {
          return response;
        })
      )
      .pipe(catchError(this.errorHandlerForHttpRequest));
  }

  // Post Method Call Retreive data from server
  postService(url: string, data?: any, customOptions?: any) {
    const httpOptions = customOptions || this.getHttpHeader();

    return this._httpclient
      .post(this.baseUrl + url, data, httpOptions)
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            console.log(error);
          }
        )
      )
      .pipe(catchError(this.errorHandlerForHttpRequest));
  }


  //public Post Method Call Retreive data from server
  publicPostService(url: string, data?: any) {
    return this._httpclient
      .post(this.baseUrl + url, data)
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            console.log(error);
          }
        )
      )
      .pipe(catchError(this.errorHandlerForHttpRequest));
  }

  putService(url: string, data?: any) {
    const httpOptions = this.getHttpHeader();
    return this._httpclient
      .put(this.baseUrl + url, data, httpOptions)
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            console.log(error);
          }
        )
      )
      .pipe(catchError(this.errorHandlerForHttpRequest));
  }

  deleteService(url: string) {
    const httpOptions = this.getHttpHeader();
    return this._httpclient
      .delete(this.baseUrl + url, httpOptions)
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            console.log(error);
          }
        )
      )
      .pipe(catchError(this.errorHandlerForHttpRequest));
  }

  fileUploadService(url: string, data: FormData) {
    return this._httpclient
      .post(this.baseUrl + url, data)
      .pipe(
        map(
          (response: any) => {
            return response;
          },
          (error: any) => {
            console.log('in get server', error);
          }
        )
      )
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    console.log(error?.error?.message);
    if (error.status != 200) {
      if (error.error) {
        error.error.message = error.error.message
          ? error.error.message
          : 'Something Went Wrong';
      } else {
        error.message = 'Something Went Wrong';
      }
    }
    return throwError(error);
  }

  download_service(url: any) {
    const headerDict = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      'Access-Control-Allow-Headers': 'Content-Disposition',
      // 'X-AUTH-TOKEN': Util.TOKEN_PREFIX + this.getAuthToken(),
    };

    return this._httpclient
      .get(this.baseUrl + url, {
        responseType: 'blob' as 'json',
        observe: 'response',
        headers: headerDict,
      })
      .subscribe(
        (res: any) => {
          const binaryData = [];
          binaryData.push(res.body);
          // const fileName = res.headers.get('filename');

          let fileName = 'file';
          const contentDisposition = res.headers.get('Content-Disposition');
          if (contentDisposition) {
            const fileNameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            const matches = fileNameRegex.exec(contentDisposition);
            if (matches != null && matches[1]) {
              fileName = matches[1].replace(/['"]/g, '');
            }
          }

          const url = window.URL.createObjectURL(
            new Blob(binaryData, { type: 'application/*' })
          );
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.href = url;
          a.download = fileName;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove(); // remove the element
        },
        (error) => {
          alert(JSON.stringify(error));
        },
        () => { }
      );
  }

  /**
   * @author Deepa Maywad
   * @description
   * Error Handler for HttpRequest
   * 30-05-2022 working Fine Above Error Hedler is not working and not given any responce message
   *
   * **/
  subject = new Subject<any>();
  errorResponse(err: any) {
    this.subject.next(err);
  }

  // getKeyToSendBackend$ = new EventEmitter<any>();
  getPrint(): Observable<any> {
    return this.subject.asObservable();
  }
  errorHandlerForHttpRequest(error: Response | any) {
    if (error.error && error.status.code === 401) {
      if (
        this.route.url != '/' ||
        this.route.url != this.activatedRouter.snapshot.queryParams['/?code']
      ) {
        localStorage.clear();
        window.location.href = '/';
      }
    } else if (error.status === 403) {
      if (error.error) {
        error.error.message = error.error.message
          ? error.error.message
          : 'You are not able to access this request';
      } else {
        error.message = 'You are not able to access this request';
      }
    } else if (
      error.status === 400 ||
      error.status === 500 ||
      error.status === 0
    ) {
      console.log(error);
      if (error.error) {
        error.error.message = error.error.status.message
          ? error.error.status.message
          : 'Something went wrong,Please try again later!';
      } else {
        error.message = 'Something went wrong,Please try again later!';
      }
    }
    return throwError(error);
  }
  isLoggedIn() {
    // let currentUser: any = JSON.parse(localStorage.getItem('currentUser')!);
    // return currentUser.token.accessToken;
    return true;
  }

  /**
   * @author Deepa
   * @description
   * Read idToken from localstorage and set in Header to call security based api
   * 30-05-2022
   *
   * **/
  private getHttpHeader() {
    let sessionId = localStorage.getItem('sessionId');
    let random = localStorage.getItem('random');
    const language = localStorage.getItem('selectedLang') ?? this.getLanguageMap[localStorage.getItem('SocialSelectedLang') ?? 'ENGLISH'] ?? 'en';
    const timeZoneOffset = new Date().getTimezoneOffset().toString();
    random = random != null ? random : '';
    sessionId = sessionId != null ? sessionId : '';
    let headerJson = null;
    if (this.getAuthToken() === '') {
      headerJson = {
        'Content-Type': 'application/json',
        'RANDOM-UID': random,
        timeDiff: timeZoneOffset,
        'Accept-Language': language,
      };
    } else {
      headerJson = {
        'Content-Type': 'application/json',
        Authorization: this.getAuthToken(),
        'SESSION-ID': sessionId,
        'RANDOM-UID': random,
        timeDiff: timeZoneOffset,
        'Accept-Language': language,
      };
    }
    const headersObj = new HttpHeaders(headerJson);
    const httpOptions = {
      headers: headersObj,
    };
    return httpOptions;
  }

  getAuthToken() {
    if (localStorage.getItem('Authorization') != null) {
      return localStorage.getItem('Authorization') ?? '';
    } else if (localStorage.getItem('ID-TOKEN') != null) {
      return localStorage.getItem('ID-TOKEN') ?? '';
    } else {
      return '';
    }
  }

  getLanguageMap: { [key: string]: string } = {
    ENGLISH: 'en',
    SPANISH: 'es',
    ITALIAN: 'it'
  };
}
